import React from "react";
import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ADMIN } from "@/constants/testIds";
import { Calendar, Megaphone, Star, Layout, Store, LogOut, QrCode } from "lucide-react";
import AdminMobileNav from "@/components/AdminMobileNav";

const navItems = [
  { to: "/admin/bookings", label: "Bookings", icon: Calendar, tid: ADMIN.navBookings },
  { to: "/admin/promotions", label: "Promotions", icon: Megaphone, tid: ADMIN.navPromos },
  { to: "/admin/reviews", label: "Reviews", icon: Star, tid: ADMIN.navReviews },
  { to: "/admin/content", label: "Content Calendar", icon: Layout, tid: ADMIN.navContent },
  { to: "/admin/qr", label: "QR Posters", icon: QrCode, tid: "admin-nav-qr" },
  { to: "/admin/business", label: "Business", icon: Store, tid: ADMIN.navBusiness },
];

export default function AdminLayout() {
  const { admin, loading, logout } = useAuth();
  const nav = useNavigate();
  if (loading) return <div className="p-10">Loading...</div>;
  if (!admin) return <Navigate to="/admin" replace/>;

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex">
      {/* Desktop sidebar */}
      <aside className="w-64 bg-[#0F172A] text-[#FFFFFF] p-6 hidden md:flex flex-col">
        <div className="font-serif-display text-2xl">Hedieh's</div>
        <div className="overline text-[#D4AF37] mt-1">Staff Portal</div>
        <nav className="mt-12 flex flex-col gap-1 flex-1">
          {navItems.map(({ to, label, icon: Icon, tid }) => (
            <NavLink key={to} to={to} data-testid={tid}
                     className={({ isActive }) => `flex items-center gap-3 px-4 py-3 text-sm ${isActive ? "bg-[#0F172A]" : "text-[#FFFFFF]/70 hover:text-[#FFFFFF] hover:bg-white/5"}`}>
              <Icon size={16}/> {label}
            </NavLink>
          ))}
        </nav>
        <div className="text-xs text-[#FFFFFF]/50 mb-2">{admin.email}</div>
        <button data-testid={ADMIN.logoutBtn} onClick={() => { logout(); nav("/admin"); }}
                className="flex items-center gap-2 text-xs text-[#FFFFFF]/70 hover:text-[#FFFFFF]">
          <LogOut size={14}/> Sign out
        </button>
      </aside>

      {/* Mobile top bar */}
      <div className="md:hidden fixed top-0 left-0 right-0 h-14 bg-[#0F172A] text-[#FFFFFF] z-40 flex items-center justify-between px-4 pt-[env(safe-area-inset-top)]">
        <div className="font-serif-display text-lg">Hedieh's <span className="overline text-[#D4AF37] ml-2">Staff</span></div>
        <button data-testid={ADMIN.logoutBtn + "-mobile"} onClick={() => { logout(); nav("/admin"); }}
                className="flex items-center gap-2 text-xs text-[#FFFFFF]/80">
          <LogOut size={14}/>
        </button>
      </div>

      <main className="flex-1 overflow-x-auto pt-14 md:pt-0 pb-20 md:pb-0">
        <Outlet/>
      </main>

      {/* Mobile bottom nav */}
      <AdminMobileNav/>
    </div>
  );
}
